import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  NumericTextBoxModule,
  TextBoxModule,
} from "@syncfusion/ej2-angular-inputs";
import { DatePickerModule } from "@syncfusion/ej2-angular-calendars";
import { TabModule, ToolbarModule } from "@syncfusion/ej2-angular-navigations";
import {
  ComboBoxModule,
  DropDownListModule,
  MultiSelectModule,
  MultiSelectAllModule,
} from "@syncfusion/ej2-angular-dropdowns";
import {
  CommandColumnService,
  EditService,
  FilterService,
  GridModule,
  PageService,
  ResizeService,
  RowDDService,
  SortService,
  ToolbarService,
} from "@syncfusion/ej2-angular-grids";
import {
  ButtonModule,
  ChipListModule,
  CheckBoxModule,
} from "@syncfusion/ej2-angular-buttons";
import { DialogModule } from "@syncfusion/ej2-angular-popups";
import { DropDownButtonModule } from "@syncfusion/ej2-angular-splitbuttons";
import { InPlaceEditorModule } from "@syncfusion/ej2-angular-inplace-editor";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { OfiOneClickEditModule } from "../modules/ofi-one-click-edit/ofi-one-click-edit.module";
import { OfiReorderGridModule } from "../modules/ofi-reorder-grid/ofi-reorder-grid.module";
import { OfiButtonGroupComponent } from "./components/ofi-button-group/ofi-button-group.component";

/**
 * The `SharedModule` is imported in to any feature module where it's children are needed. And, those children are almost
 * always a **dumb** components, directives, and pipes. Generally, `SharedModule` is not imported in to the `AppModule` or `CoreModule`,
 * if you're considering importing the `SharedModule` there to access a child, and the child is single-use, perhaps that child should
 * be moved in to the `CoreModule`.
 *
 * A shared module that needs to be added to a lazy loaded module should **not** have providers, because that would create duplicate
 * service instances. (You could have providers, if duplicate services are intended).
 */
@NgModule({
  declarations: [OfiButtonGroupComponent],
  imports: [CommonModule, MatIconModule],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TextBoxModule,
    NumericTextBoxModule,
    DatePickerModule,
    TabModule,
    ComboBoxModule,
    GridModule,
    ButtonModule,
    DialogModule,
    ChipListModule,
    CheckBoxModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatDialogModule,
    MatMenuModule,
    MatIconModule,
    MultiSelectModule,
    DropDownListModule,
    DropDownButtonModule,
    InPlaceEditorModule,
    ToolbarModule,
    MultiSelectAllModule,
    OfiButtonGroupComponent,
    OfiOneClickEditModule,
    OfiReorderGridModule,
  ],
  providers: [
    PageService,
    SortService,
    FilterService,
    ResizeService,
    EditService,
    ToolbarService,
    CommandColumnService,
    RowDDService,
  ],
})
export class SharedModule {} // Don't think about using ModuleWithProviders here until you read this module's docs.
